import React, { Component } from 'react';
import { startIdentityAuth } from '@riotgames/kr-identity-sdk';
import { Button, ButtonType, Checkbox, Spinner } from '@riotgames/accounts-react-components';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import cx from 'classnames';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';
import AppContext from '../../AppContext';
import ConsentTypo from '../../comps/ConsentTypo';
const VALID_AUTHCALLBACK_PATH = '/auth';

class ParentConsentsAndSelfAuth extends Component {
  static contextType = AppContext;

  state = {
    shouldWaitForVerifiedAuth: false,
    isVerifiedAuth: false,
    consentOfMinor: '',
    consentOfParentPrivacy: '',
    consents: {
      pi: false,
      usage: false,
      privacy: false
    }
  };

  async componentDidMount() {
    const { history } = this.props;
    const authToken = this.callbackAuthToken(this.props.location);

    if (authToken) {
      this.setState({ shouldWaitForVerifiedAuth: true });
      const verifiedPI = await this.onVerified(authToken);
      this.setState({ shouldWaitForVerifiedAuth: false });

      if (verifiedPI) {
        this.setState({ isVerifiedAuth: true });
      }

      history.replace('/'); // location replace to '/' for removing callback path and token
    }

    const {
      actions: { api }
    } = this.context;

    // TODO: 14, 18 age
    this.loadConsent(api('/signup/v1/account/consent/minor/gameplay/14'), (text) =>
      this.setState({ consentOfMinor: text })
    );
    this.loadConsent(api('/signup/v1/account/consent/parent/privacy/14'), (text) =>
      this.setState({ consentOfParentPrivacy: text })
    );
  }

  /** consents */
  onConsented(id) {
    const { consents } = this.state;
    consents[id] = !consents[id];

    this.setState({ consents });
  }
  loadConsent(url, callback) {
    fetch(url, {
      method: 'GET',
      cache: 'no-cache'
    })
      .then((response) => response.text())
      .then(callback);
  }

  moveNext = () => {
    this.props.handleMoveNext();
  };

  callbackAuthToken = (location) => {
    const isValidPath = location.pathname === VALID_AUTHCALLBACK_PATH;
    const token = queryString.parse(location.search).result;

    return isValidPath && !!token && token;
  };

  update(params) {
    const { actions } = this.context;
    actions.setData(params);
  }

  onVerified = async (authToken) => {
    const {
      actions: { acquirePI, acquireParentPI, setData }
    } = this.context;

    try {
      const { data } = await acquirePI(authToken);
      await acquireParentPI(authToken);

      setData({
        parentAuthInfo: authToken
      });

      return data;
    } catch (e) {
      this.update({
        hasError: true,
        errorHeader: '법정대리인 동의 오류',
        errorDetail: `
          이전 계정 생성할 때 인증해준 법정대리인과 현재 법정대리인이 다른 경우.\n
          법정대리인과 미성년자의 나이 차이가 20살 미만인 경우.\n
          법정대리인이 이미 동의한 미성년자가 3명 이상인 경우.
        `
      });
    }
  };

  handleSelfAuth = (e) => {
    const {
      state: { identity }
    } = this.context;
    const { identityCode, env } = identity;
    const callbackUrlPort = location.port ? `:${location.port}` : '';
    const callbackUrlHost = `${location.protocol}//${location.hostname}${callbackUrlPort}`;

    startIdentityAuth({
      serviceType: identityCode,
      environment: env,
      isPopup: false,
      callbackUrl: `${callbackUrlHost}/auth?result={}`
    });
  };

  isAgreed(age) {
    const {
      consents: { pi, usage, privacy }
    } = this.state;
    return age < 14 ? pi && usage && privacy : usage && privacy;
  }

  render() {
    const { isVerifiedAuth, shouldWaitForVerifiedAuth } = this.state;
    const {
      state: { age }
    } = this.context;

    const isMinor14 = age < 14;
    const isAgreed = this.isAgreed(age);
    const consentPrefix = isMinor14 ? 'u14' : 'u18';
    const subTitlePanelDefault = isMinor14 ? (
      <p className="help-text">만 14세 미만의 경우 게임 이용 및 개인정보 수집에 대한 법정대리인의 동의가 필요합니다.</p>
    ) : (
      <p className="help-text">만 18세 미만의 경우 게임 이용에 대한 법정대리인의 동의가 필요합니다.</p>
    );
    const subTitlePanel = !isVerifiedAuth ? (
      subTitlePanelDefault
    ) : (
      <p className="help-text">
        법정대리인 본인인증이 완료 되었습니다. 자녀의 게임 이용내역 등의 소식을 받기 위한 법정대리인 이메일 등록이
        필요합니다.
      </p>
    );

    const submitButton = !isVerifiedAuth ? (
      <Button
        buttonType={ButtonType.primary}
        disabled={!isAgreed}
        label="법정대리인 인증"
        onClick={this.handleSelfAuth}
      />
    ) : (
      <Button buttonType={ButtonType.submit} onClick={this.moveNext} />
    );

    return (
      <GridPanel title={'법정대리인 동의'} subTitle={!shouldWaitForVerifiedAuth && subTitlePanel} button={submitButton}>
        <Grid
          direction={GridDirection.vertical}
          align={GridAlignment.center}
          justify={GridJustify.spaceBetween}
          fill={true}
        >
          {shouldWaitForVerifiedAuth && <Spinner />}
          {!shouldWaitForVerifiedAuth && !isVerifiedAuth && (
            <>
              <Grid
                direction={GridDirection.vertical}
                align={GridAlignment.center}
                justify={GridJustify.spaceBetween}
                fill={true}
              >
                <ul className="consent-list">
                  {age < 14 && (
                    <li>
                      <Checkbox
                        onCheckedChange={() => this.onConsented('pi')}
                        disabled={isVerifiedAuth}
                        labelComponent={
                          <ConsentTypo
                            strongText={'미성년자의 개인정보 수집 및 이용'}
                            text={' 동의 (필수)'}
                            consentName={`${consentPrefix}/pi`}
                          />
                        }
                      />
                    </li>
                  )}
                  <li>
                    <Checkbox
                      onCheckedChange={() => this.onConsented('usage')}
                      disabled={isVerifiedAuth}
                      labelComponent={
                        <ConsentTypo
                          strongText={'미성년자의 게임 이용'}
                          text={' 동의 (필수)'}
                          consentName={`${consentPrefix}/usage`}
                        />
                      }
                    />
                  </li>
                  <li>
                    <Checkbox
                      onCheckedChange={() => this.onConsented('privacy')}
                      disabled={isVerifiedAuth}
                      labelComponent={
                        <ConsentTypo
                          strongText={'법정대리인 개인정보 수집 및 이용'}
                          text={' 동의 (필수)'}
                          consentName={`${consentPrefix}/privacy`}
                        />
                      }
                    />
                  </li>
                </ul>
              </Grid>
            </>
          )}
        </Grid>
      </GridPanel>
    );
  }
}

export default withRouter(ParentConsentsAndSelfAuth);
